import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainChangeDevice(params) {
  return maintainRequest({
    url: `/device/maintenanceMan/chargingPile/changeDevice`,
    method: "post",
    params,
  });
}
